import { render, staticRenderFns } from "./OverviewItem.vue?vue&type=template&id=45cd5f33"
import script from "./OverviewItem.vue?vue&type=script&lang=ts"
export * from "./OverviewItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports